<template>
  <DsShowcase title="ButtonPlayV2" description="Botão principal do design system. Suporta variantes visuais, tamanhos, ícones e estados.">
    <!-- PROP: variant -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">variant</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'filled' | 'outline' | 'ghost'</code> — padrão: <code>filled</code></p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="Filled" variant="filled" />
        <ButtonPlayV2 text="Outline" variant="outline" />
        <ButtonPlayV2 text="Ghost" variant="ghost" />
      </div>
    </section>

    <!-- PROP: size -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">size</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'sm' | 'md' | 'lg'</code> — padrão: <code>md</code></p>
      <div class="tw:flex tw:items-end tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="Small" size="sm" />
        <ButtonPlayV2 text="Medium" size="md" />
        <ButtonPlayV2 text="Large" size="lg" />
      </div>
    </section>

    <!-- PROP: color -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">color</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — qualquer cor CSS. Padrão: <code>var(--maincolor)</code></p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="#e53e3e" color="#e53e3e" />
        <ButtonPlayV2 text="#38a169" color="#38a169" />
        <ButtonPlayV2 text="#3182ce" color="#3182ce" />
        <ButtonPlayV2 text="#7c3aed" color="#7c3aed" />
        <ButtonPlayV2 text="#f59e0b" color="#f59e0b" />
      </div>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap tw:mt-3">
        <ButtonPlayV2 text="Outline" color="#7c3aed" variant="outline" />
        <ButtonPlayV2 text="Ghost" color="#7c3aed" variant="ghost" />
      </div>
    </section>

    <!-- PROP: icon / iconRight -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">icon / iconRight</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — nome de ícone Material Symbols</p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="Com ícone à esquerda" icon="check" />
        <ButtonPlayV2 text="Com ícone à direita" icon-right="arrow_forward" />
        <ButtonPlayV2 text="Ambos" icon="download" icon-right="open_in_new" />
        <ButtonPlayV2 icon="add" />
        <ButtonPlayV2 icon="delete" variant="outline" color="#e53e3e" />
      </div>
    </section>

    <!-- PROP: loading -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">loading</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — exibe spinner e bloqueia clique</p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="Salvando..." :loading="true" />
        <ButtonPlayV2 text="Enviando" :loading="true" variant="outline" />
        <ButtonPlayV2 icon="refresh" :loading="true" variant="ghost" />
      </div>
    </section>

    <!-- PROP: disabled -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">disabled</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — desabilita interação</p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="Disabled filled" :disabled="true" />
        <ButtonPlayV2 text="Disabled outline" :disabled="true" variant="outline" />
        <ButtonPlayV2 text="Disabled ghost" :disabled="true" variant="ghost" />
      </div>
    </section>

    <!-- PROP: skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">skeleton</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — estado de loading skeleton</p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="Skeleton" :skeleton="true" />
        <ButtonPlayV2 text="Skeleton lg" :skeleton="true" size="lg" />
      </div>
    </section>

    <!-- PROP: href -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">href</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — renderiza como <code>&lt;a&gt;</code> com target _blank</p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="Link externo" icon="open_in_new" href="https://google.com" />
      </div>
    </section>

    <!-- PROP: type -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">type</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'button' | 'submit' | 'reset'</code> — padrão: <code>button</code></p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <ButtonPlayV2 text="Submit" type="submit" icon="send" />
        <ButtonPlayV2 text="Reset" type="reset" variant="ghost" icon="restart_alt" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import DsShowcase from '../DsShowcase.vue'
import { ButtonPlayV2 } from "@/components/atomic"
</script>
